import {isBrowser} from '@ultradent/utilities/Window';
import i18next from 'i18next';
import ReactPostprocessor from 'i18next-react-postprocessor';

// note - future fallback HttpBackend from 'i18next-http-backend'
//  integration resource - https://www.i18next.com/how-to/backend-fallback;

export const t = i18next.t.bind( i18next );
const lang = isBrowser() && navigator.language || 'en-us';

// preloaded resources from js file
let _initialized = false;
const i18nFactory = () => {

    if ( _initialized ) {
        return
    }

    _initialized = true;

    i18next
        .use( new ReactPostprocessor() )
        .init( {
            // note - if using a language detector, do not define the lng option
            lng: lang,
            debug: process.env.NODE_ENV === 'development',
            resources: {
                [lang]: {
                    translation: isBrowser() && window.upi?.i18n?.translations
                }
            },
            interpolation: {
                format: function ( value, format, lng ) {
                    if ( format === 'uppercase' ) {
                        return value.toUpperCase();
                    }

                    return value;
                }
            }
        }, ( err, tFunc ) => {
            if ( err ) {
                console.error( '[Failed to load translations]', err );
            }
        } );
}

i18nFactory();

